export const RANKING_DISTRIBUTION_DICTIONARY = {
    ERROR_TITLE: "common.error",
    ERROR_SUBTITLE: "common.error.subtitle",
    NO_DATA_TITLE: "common.noresults",
    NO_DATA_SUBTITLE: "common.noresults.subtitle",
    TITLE: "ranking.distribution.position.summary",
    PRIMARY_METRIC: "ranking.distribution.by.position",
    SECONDARY_METRIC: "ranking.distribution.by.website",
    POSITIONS: "ranking.distribution.positions",
    WEBSITE: "ranking.distribution.website",
    KEYWORDS: "ranking.distribution.keywords",
    CHANGE: "ranking.distribution.columns.change",
    DOMAIN: "ranking.distribution.domain",
    TOTAL: "ranking.distribution.total",
    RANKING_DISTRIBUTION_PRIMARY_METRIC_FIRST_TABLE_TITLE: "ranking.distribution.total.hashtag.kws",
    RANKING_DISTRIBUTION_PRIMARY_METRIC_SECOND_TABLE_TITLE: "ranking.distribution.of.keywords",
    TOTAL_KEYWORDS: "ranking.distribution.total.keywords",
    OF_KEYWORDS: "ranking.distribution.of.keywords",
    OF_SITE_KEYWORDS: "ranking.distribution.of.site.keywords",
    BY_POSITION_CATEGORIES: "ranking.distribution.chart.by.position.category",
    BY_POSITION_TOOLTIP: "ranking.distribution.chart.by.position.category.full",
    BY_WEBSITE_TOOLTIP: "ranking.distribution.chart.by.website.keyword.ranking",
    TABLE_POSITION: "ranking.distribution.legends.table.position",
    LAST_LEGEND_LIST: "ranking.distribution.last.legend.list",
};
